import React, { useState, useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { useWindowSize } from "@react-hook/window-size";
import { Row, Col, Input, FormGroup, Label, Button } from "reactstrap";
import Strip from "../customComponent/Strip/Strip";
import ExternalLayout from "../customComponent/ExternalLayout/ExternalLayout";
import RenderPage from "../customComponent/RenderPage/RenderPage";
import SEOComponent from "../customComponent/SEO/SEOComponent";
import CustomPagination from "./Home/CustomPagination";
import getTestData from '../../api/services/TestService';
import getPatients from "../../api/services/getPatients";
import application_contants from "../constants/application_contant";
import UserData from "../Utils/Json/UserData";



const Users = () => {
  const [width] = useWindowSize();
  const [data, setData] = useState([]);
  const [Patient_id, setPatient_id] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const cardsPerPage = 10; // Change this to the number of cards per page
  const totalCards = UserData.length; // Assuming 'data' is the array of cards
  const totalPages = Math.ceil(totalCards / cardsPerPage);

  

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  
  React.useEffect(() => {
    window.scrollTo(0, 0);
    getList();
  }, []);

  const getList = async () => {
    setIsLoading(true);
    await getPatients
      .getPatientslist()
      .then(async (res) => {
        if (res.status === 200) {
          try {
            res.text().then(async (res) => {
              let result = JSON.parse(res);
              console.log("result", result);
              if (result.length > 0) {
                setData(result);
                setIsLoading(false);
              } else {
                setData(result);
                setIsLoading(false);
              }
            });
          } catch (err) {
            console.log(err);
            setIsLoading(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  




  return (
    <ExternalLayout>
      <RenderPage
        id="tst-landing"
        className={`render px-0 render-page`}
        containerType="container-fluid"
      >
        <Strip
          id="tst-strip-Video"
          className="strip strip-no-padding "
          containerType="container-fluid mb-5 mt-5"
        >
          <SEOComponent
            title="Users"
            keywords="Users"
            description="Antlia"
            siteUrl="/Antlia"
          />
          <Row className="mx-0 background-container container mx-5">
            <Col
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={11}
              className="m-auto  pt-4 "
            >
              <Row>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="pt-3 pl-5 "
                >
                  <p className="p-small title-bold2 align-left">
                    <span className="p-small section-title title-bold1">
                      Users
                    </span>
                  </p>
                  <p className="pt-3">
                    <CustomPagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                      resultsPerPage={cardsPerPage}
                      totalPatients={totalCards}
                    />
                  </p>

                  <table className="custom-table section-title p-5">
                    <thead>
                      <tr className="pl-5">
                        <th className="p-lesserthan-small">Name of Users</th>
                        <th
                          className="p-lesserthan-small"
                          style={{ width: "20%" }}
                        >
                          Mobile No.
                        </th>
                        <th className="p-lesserthan-small">Team</th>
                        <th className="p-lesserthan-small" style={{ width: "10%" }}>Role</th>
                        <th
                          className="p-lesserthan-small"
                          style={{ width: "10%" }}
                        >
                          Status
                        </th>
                        <th
                          className="p-lesserthan-small"
                          style={{ width: "20%" }}
                        >
                          Actions
                        </th>
                        
                      </tr>
                    </thead>
                    <tbody>
                      {UserData.map((row) => (
                        <tr key={row.id}>
                          <td className="p-lesserthan-small ">
                            {row.name}
                          </td>
                          <td className="p-lesserthan-small ">
                            {row.number}
                          </td>
                          <td className="p-lesserthan-small">{row.team}</td>
                          <td className="p-lesserthan-small">{row.role}</td>
                          <td className="p-lesserthan-small custom-reference-links">{row.status}</td>
                          <td className="p-lesserthan-small">{row.action}</td>
                          
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Col>
              </Row>
            </Col>
          </Row>
        </Strip>
      </RenderPage>
    </ExternalLayout>
  );
};

export default Users;
